import React from 'react';
import Message from './Message';

class SalesConfirm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            error: false,
            errorText: "",
            success: false,
            message: "",
            title: ""
        }
    }

    invalidToken() {
        return !this.props.token || this.props.token.length < 8;
    }

    componentDidMount() {
        if (this.invalidToken()) return;

        var that = this;
        that.setState({ loading: true});

        fetch( that.props.targetUrl + "customerconfirm/" + that.props.token, {
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': window.location.protocol + "//" + window.location.host,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
            }).then(function(response){
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                return response.json().then(function(res){
                var error = new Error();
                error.response = res.text;
                error.title = res.title;
                throw error;
                });
            }
            }).then(function(data){
                that.setState({loading: false, success: true, message: data.text, title: data.title})
            }).catch(function(error){
                that.setState({loading: false, error: true, errorText: error.response, title: error.title});
        });
    }

    render() {
        const invalidToken = this.invalidToken();
        
        var display = {
            loading: this.state.loading
        };

        if (invalidToken){
            display.header = "Ungültiges Registrierungs-Token";
            display.message = "Das Registrierungs-Token ist ungültig.";
        }else if (this.state.loading){
            display.header = "Ihre Anfrage wird bearbeitet - bitte einen Moment Geduld";
        }else if (this.state.error){
            if (this.state.title){
                display.header = this.state.title;
            }else{
                display.header = "Es ist ein Fehler aufgetreten";
            }

            if (this.state.errorText){
                display.message = this.state.errorText;
            }else{
                display.message = "Ihre Anfrage konnte leider nicht verarbeitet werden. Bitte versuchen Sie es in einigen Minuten erneut.";
            }
        }else if (this.state.success){
            if (this.state.title){
                display.header = this.state.title;
            }else{
                display.header = "Registrierung abgeschlossen";
            }

            if (this.state.message){
                display.message = this.state.message;
            }else{
                display.message = "Vielen Dank für Ihr Interesse.";
            }
            
        }

        return (
            <Message loading={display.loading} header={display.header} message={display.message} />
        );
    }
}

export default SalesConfirm;


// WEBPACK FOOTER //
// ./src/components/SalesConfirm.js